/* eslint-disable import/prefer-default-export */
import { DefaultTheme } from 'styled-components';

export interface IColorProps {
	color?: string;
	theme: DefaultTheme;
}

export const applyColorFromProps = (props: IColorProps, fallbackColor: string): string => {
	const colors = props.theme.colors as any as Record<string, string>;
	return props.color != null ? colors[props.color] : colors[fallbackColor];
};
